import tables from '../slices/tables';
import type { RootStateType } from '../index';

export const {
    setTableOptions
} = tables.actions;

export const selectTableOptions = (name: string) => (state: RootStateType) => state.tables.options[name];
